import { useEffect, useRef } from "react";
import DefaultButton from "./DefaultButton";

export default function TextVideo({ title, description, videoSrc }) {
    const videoRef = useRef(null);

    useEffect(() => {
        const video = videoRef.current;
        if (!video) return;

        video.muted = true;
        video.play().catch(() => {});
    }, []);

    return (
        <section className="flex flex-col md:flex-row min-h-screen md:h-screen">
           <div className="flex flex-col justify-center px-6 py-5 md:px-14 gap-10 md:w-1/2 text-center md:text-left">
                <h2 className="lg:text-5xl text-4xl text-mcare font-semibold md:drop-shadow-lg text-balance panoragraf-light">
                    {title}
                </h2>

                {description}
                <DefaultButton text="Prenota una visita" link="#contatti" buttonClass="lg:w-full xl:w-1/2" />
            </div>
            <div className="w-full md:w-1/2 h-full">
                <video
                    ref={videoRef}
                    src={videoSrc}
                    autoPlay
                    loop
                    muted
                    playsInline
                    preload="auto"
                    className="w-full h-full object-cover shadow-lg"
                />
            </div>
        </section>
    );
}